module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="notify no-results">\n	';
 if ( searchQuery ) { 
__p+='\n\n		<h3>'+
((__t=( __('searchquery_no_result_title', {searchQuery: searchQuery}) ))==null?'':__t)+
'</h3>\n		'+
((__t=( __('searchquery_no_result_match') ))==null?'':__t)+
'\n\n	';
 } else { 
__p+='\n\n		';
 if ( favoritesOnly ) { 
__p+='\n\n			<h3>'+
((__t=( __('favsonly_empty_title') ))==null?'':__t)+
'</h3>\n			'+
((__t=( __('favsonly_empty_text') ))==null?'':__t)+
'\n\n		';
 } else { 
__p+='\n\n			<h3>'+
((__t=( registry("Engine.NoResultTitle") ))==null?'':__t)+
'</h3>\n			<p>'+
((__t=( registry("Engine.NoResultMessage") ))==null?'':__t)+
'</p>\n\n		';
 }  
__p+='\n\n\n	';
 }  
__p+='\n</div>\n';
}
return __p;
};


/*****************
 ** WEBPACK FOOTER
 ** /Users/mitch/jsapps/modules/reserva/templates/engine/no-results.html
 ** module id = 59
 ** module chunks = 0
 **/